var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 40,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.00781H58V38H18V5.00781Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 24.5469L23.6719 21.8828V36.5391C23.6719 37.2344 24.2344 37.7969 24.9297 37.7969H49.9922C50.6875 37.7969 51.25 37.2344 51.25 36.5391V21.8828L53.9297 24.5469C55.1016 25.7109 56.875 23.9297 55.7032 22.7734L50.8907 17.9609L38.3594 5.44531C37.8672 4.96094 37.0703 4.96094 36.5782 5.44531L32.9453 9.07812V6.80469C32.9453 6.11719 32.3828 5.54688 31.6875 5.54688H26.875C26.1797 5.54688 25.6094 6.11719 25.6094 6.80469V16.4062L24.0625 17.9531L19.2422 22.7656C18.0625 23.9297 19.8203 25.7109 21 24.5469ZM37.461 8.10156L48.7344 19.3594V35.2812H26.1875V19.3594L32.5703 12.9922L37.461 8.10156ZM28.1172 8.07031H30.4141V11.5781L28.1172 13.875V8.07031Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 24,
    width: 75,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.523438 24H74.0156V69.5078H0.523438V24Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0234 26.7659C74.0312 26.1019 73.4296 25.5081 72.7578 25.5237H60.5859C58.9453 25.5237 58.9296 28.0237 60.5859 28.0394H69.7109L53.9999 43.7269H22.7343C22.3671 43.7269 22.0312 43.8831 21.789 44.1409L1.21869 67.1878C0.484321 67.9534 1.10151 69.3284 2.16401 69.2894C2.49994 69.2894 2.85151 69.1487 3.10932 68.8753L23.3046 46.2581H54.5312C54.8593 46.2581 55.1874 46.1175 55.4296 45.8909L71.4999 29.8284V38.9456C71.5156 40.5941 74.0078 40.5941 74.0234 38.9456C74.0234 38.93 74.0312 26.7816 74.0234 26.7659Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 36,
    width: 4,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36H70V69.5078H66V36Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6641 36.9375C67.9688 36.9375 67.4062 37.5078 67.4062 38.2031V68.1797C67.4062 68.875 67.9688 69.4375 68.6641 69.4375C69.3594 69.4375 69.9219 68.875 69.9219 68.1797V38.2031C69.9219 37.5078 69.3594 36.9375 68.6641 36.9375Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 42,
    width: 4,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42H64V69.5078H60V42Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8203 43.2031C61.125 43.2031 60.5547 43.7656 60.5547 44.4609V68.1797C60.5547 68.875 61.125 69.4375 61.8203 69.4375C62.5156 69.4375 63.0781 68.875 63.0781 68.1797V44.4609C63.0781 43.7656 62.5156 43.2031 61.8203 43.2031Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 48,
    width: 6,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48H58V69.5078H52V48Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9766 48.7422C54.2813 48.7422 53.7109 49.3047 53.7109 50V68.1953C53.7109 68.8906 54.2813 69.4531 54.9766 69.4531C55.6641 69.4531 56.2344 68.8906 56.2344 68.1953V50C56.2344 49.2969 55.6641 48.7422 54.9766 48.7422Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 48,
    width: 4,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48H50V69.5078H46V48Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.125 48.7422C47.4375 48.7422 46.8672 49.3047 46.8672 50V68.1953C46.8672 68.8906 47.4375 69.4531 48.125 69.4531C48.8203 69.4531 49.3906 68.8906 49.3906 68.1953V50C49.3906 49.2969 48.8203 48.7422 48.125 48.7422Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 48,
    width: 4,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48H44V69.5078H40V48Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2812 48.7422C40.5859 48.7422 40.0234 49.3047 40.0234 50V68.1953C40.0234 68.8906 40.5859 69.4531 41.2812 69.4531C41.9766 69.4531 42.5391 68.8906 42.5391 68.1953V50C42.5391 49.2969 41.9766 48.7422 41.2812 48.7422Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 48,
    width: 4,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48H36V69.5078H32V48Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 48.7422C33.7422 48.7422 33.1719 49.3047 33.1719 50V68.1953C33.1719 68.8906 33.7422 69.4531 34.4375 69.4531C35.1328 69.4531 35.6953 68.8906 35.6953 68.1953V50C35.6953 49.2969 35.1328 48.7422 34.4375 48.7422Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 48,
    width: 4,
    height: 22
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26 48H30V69.5078H26V48Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5938 48.7422C26.8984 48.7422 26.3281 49.3047 26.3281 50V68.1953C26.3281 68.8906 26.8984 69.4531 27.5938 69.4531C28.2813 69.4531 28.8516 68.8906 28.8516 68.1953V50C28.8516 49.2969 28.2813 48.7422 27.5938 48.7422Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 54,
    width: 6,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54H24V69.5078H18V54Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7422 54.5703C20.0547 54.5703 19.4844 55.1328 19.4844 55.8281V68.1953C19.4844 68.8906 20.0547 69.4531 20.7422 69.4531C21.4375 69.4531 22.0078 68.8906 22.0078 68.1953V55.8281C22.0078 55.1328 21.4375 54.5703 20.7422 54.5703Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_93_993",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 60,
    width: 4,
    height: 10
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 60H16V69.5078H12V60Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_93_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8984 61.5547C13.2031 61.5547 12.6406 62.125 12.6406 62.8203V68.1953C12.6406 68.8906 13.2031 69.4531 13.8984 69.4531C14.5938 69.4531 15.1563 68.8906 15.1563 68.1953V62.8203C15.1563 62.125 14.5938 61.5547 13.8984 61.5547Z",
    fill: "#151515"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4765 24.8906H38.4296C39.1484 24.8906 39.7421 25.4844 39.7421 26.2031C39.8281 27.1719 39.5937 28.1641 38.4296 28.2031H36.4765C35.7577 28.2031 35.164 27.6094 35.164 26.8906C35.164 26.2031 34.6015 25.6328 33.9062 25.6328C33.2109 25.6328 32.6484 26.2031 32.6484 26.8906C32.6484 28.9062 34.2187 30.5469 36.2031 30.6953V31.4922C36.2031 32.1797 36.7656 32.75 37.4609 32.75C38.1562 32.75 38.7187 32.1797 38.7187 31.4922V30.6953C41.0156 30.5469 42.5312 28.4297 42.2812 26.2031C42.2812 24.0937 40.5624 22.375 38.4452 22.375H36.4921C35.3827 22.3359 35.0781 21.3672 35.1796 20.4219C35.1796 19.7031 35.7734 19.1094 36.4921 19.1094H38.4452C39.164 19.1094 39.7577 19.7031 39.7577 20.4219C39.7577 21.1094 40.3202 21.6797 41.0156 21.6797C41.7109 21.6797 42.2812 21.1094 42.2812 20.4219C42.2812 18.4063 40.7031 16.7656 38.7187 16.6172V15.8203C38.7187 15.1328 38.1562 14.5625 37.4609 14.5625C36.7656 14.5625 36.2031 15.1328 36.2031 15.8203V16.6172C31.2812 16.9844 31.5077 24.8672 36.4765 24.8906Z",
    fill: "#151515"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketResearch);
export default __webpack_public_path__ + "static/media/MarketResearch.330c8da87b5b5883ace4c96860b8ad0b.svg";
export { ForwardRef as ReactComponent };